import { useState } from 'react'
import {useDebouncedCallback} from 'use-debounce'
import styles from './MemberSelectField.module.scss'
import {
  Box, ButtonLink,
  Modal,
  FormItem, Select, UserItem
} from 'common/components'
import {FIELD_RULES} from 'common/constants'
import UserForm from '../../users/components/UserForm'
import {useGetAllUsersList} from '../../users'

export default function MemberSelectField({readOnly}:{
  readOnly?: boolean
}) {
  const {data: members, isLoading: isLoading} = useGetAllUsersList()
  const [search, setSearch] = useState('')
  const [isSelectOpen, setSelectOpen] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)

  const handeSelectOpenSet = (open: boolean) => setSelectOpen(open)
  const handleModalClose = () => setModalOpen(false)
  const handleModalOpen = () => {
    setSelectOpen(false)
    setModalOpen(true)
  }

  const debouncedSetSearch = useDebouncedCallback(
    (value) => setSearch(value.toLocaleLowerCase?.()),
    300
  )

  const options = members?.filter(
    (item)=> !!item.firstName
  ).filter(
    (item) => (search === '') || 
    // item.firstName.toLocaleLowerCase().includes(search) ||
    // item.lastName?.toLocaleLowerCase().includes(search) ||
    [item.firstName, item.lastName].filter((x:string) => !!x).join(' ').toLocaleLowerCase().includes(search.trim())
  ).map((item) => ({
    value: item.uuid,
    label: <UserItem showDisplayId={false} user={item} />,
  })) || []

  return (
    !!readOnly ?
    <FormItem name="member" label="Select member" rules={FIELD_RULES}>
      <Select className={styles.root} placeholder="Search user"
        readOnly={true}
        loading={isLoading}
        options={options}
      />
    </FormItem>
    :
    <FormItem name="member" label="Select member" rules={FIELD_RULES}>
      <Select className={styles.root} placeholder="Search user"
        loading={isLoading}
        options={options}

        showSearch
        filterOption={false}
        onSearch={debouncedSetSearch}
        onChange={() => debouncedSetSearch('')}

        open={isSelectOpen}
        onDropdownVisibleChange={handeSelectOpenSet}
        dropdownRender={(menu) => (
          <>
            {menu}
            <>
              <Box pl={14} mt={12}>
                <ButtonLink onClick={handleModalOpen}>
                  Create user…
                </ButtonLink>
              </Box>
              <Modal
                title="New user"
                open={isModalOpen}
                onCancel={handleModalClose}
              >
                <UserForm 
                  onClose={handleModalClose}
                />
              </Modal>
            </>
          </>
        )}
      />
    </FormItem>
  )
}
